// import { inject } from '@angular/core';
// import { firstValueFrom } from 'rxjs';
// import { VehicleService } from '../vehicle.service';
import { preloadedVehiclesBrands } from '../../data-preloaded/vehicles-brands-data';
import { preloadedVehiclesModels } from '../../data-preloaded/vehicles-models-data';
import preloadedTopVehiclesYearsModels from '../../data-preloaded/top-vehicles-years-models-data';
import { MarcaVehiculo } from '../../types/vehicle.types';
import { ModeloVehiculo, ModeloAniosAplica } from '../../types/vehicle.types';

// RESOLVERS PARA VEHÍCULOS

/**
 * Resolver para obtener marcas de vehículos (top brands)
 * @param route - Información de la ruta actual
 * @returns Promise con la respuesta de marcas
 */
export const vehicleBrandsResolver = async (): Promise<MarcaVehiculo[]> => {
  // const vehicleService = inject(VehicleService);

  try {
    // const response = await firstValueFrom(vehicleService.getVehicleBrands());
    return preloadedVehiclesBrands;
    // return response.data;
  } catch (error) {
    // Fallback a datos mock en caso de error
    return [];
  }
};

/**
 * Resolver para obtener modelos de vehículos
 * @param route - Información de la ruta actual
 * @returns Promise con la respuesta de modelos
 */
export const vehicleModelsResolver = async (): Promise<ModeloVehiculo[]> => {
  // const vehicleService = inject(VehicleService);

  try {
    // const response = await firstValueFrom(vehicleService.getVehicleModels());
    return preloadedVehiclesModels;
    // return response.data;
  } catch (error) {
    // Fallback a datos mock en caso de error
    return [];
  }
};

/**
 * Resolver para obtener top vehículos con años y modelos
 * @returns Promise con la respuesta de top vehículos con años y modelos
 */
export const topVehiclesYearsModelsResolver = async (): Promise<
  ModeloAniosAplica[]
> => {
  try {
    return preloadedTopVehiclesYearsModels || [];
  } catch (error) {
    // Fallback a datos vacíos en caso de error
    return [];
  }
};
